import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Post from "Post";


export interface SingularPostProps {

};

const SingularPost = (props: SingularPostProps) => {
  return(
    <Box  minWidth='320px' maxWidth='1024px' m='0 auto' paddingTop={2}>
      <Post />
    </Box>
  )
}


export default SingularPost;